
const apiFetch = async (url, options = {}) => {
  const res = await fetch(url, {
    ...options,
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...options.headers },
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.message || `Request failed: ${res.status}`);
  }
  if (res.status === 204) return null;
  const text = await res.text();
  return text ? JSON.parse(text) : null;
};

export const channelService = {
  getChannels: (chatbotId) =>
    apiFetch(`/api/chatbots/${chatbotId}/channels`),

  createChannel: (chatbotId, data) =>
    apiFetch(`/api/chatbots/${chatbotId}/channels`, {
      method: 'POST',
      body: JSON.stringify(data),
    }),

  updateChannel: (chatbotId, channelId, data) =>
    apiFetch(`/api/chatbots/${chatbotId}/channels/${channelId}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    }),

  deleteChannel: (chatbotId, channelId) =>
    apiFetch(`/api/chatbots/${chatbotId}/channels/${channelId}`, { method: 'DELETE' }),

  toggleChannel: (chatbotId, channelId) =>
    apiFetch(`/api/chatbots/${chatbotId}/channels/${channelId}/toggle`, { method: 'PUT' }),
};
